<template>
    <div class="row">
        <div class="col-1">
        </div>
        <div class="col-11">
            <div v-for="category in flightHours" :key="category.global.key">
                <div v-if="category.global.duration || category.global.count">

                    <h5 :class="catTitleClass(category.global)">{{ lang.polaris.flight_hours[category.global.key] }}</h5>

                    <p class="mb-1"><small>{{ catDetails(category.global) }}</small></p>

                    <div class="mb-3" v-if="Object.keys(category.series).length">
                        <small v-for="serie in category.series" :key="serie.serieKey" 
                            style="background-color:#ddd;padding:2px 4px;" class="mr-1">
                            {{ serieDetails(serie) }}
                        </small>
                    </div>
                    <div class="mb-3" v-else></div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    
        props: {
            id: null,
            courseId: null,
            bus: null
        },
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/phases/'+this.courseId+'/flight-hours',
                flightHours: [],
                loaded: false
            }
        },

        created: function() {
            this.bus.$on(this.id+'-modal-open', this.load);
        },

        methods: {
        
            load: function() {
                var that = this;
                this.loaded = false;
                axios.get(this.endpoint)
                    .then(function (response) {
                        that.display(response.data.data);
                    })
                    .catch(function (error) {
                    });
            },

            display: function(data) {
                this.loaded = true;
                this.flightHours = [];

                // Total hours color
                for (var index in data) {
                    var item = data[index];

                    // New hours format, including series.
                    if (typeof item.global === "undefined") {
                        var global = item;
                        this.flightHours.push({global: item, series: {}});
                    } else {
                        var global = item.global;
                        this.flightHours.push(item);
                    }
                }
            },

            catTitleClass: function(category) {
                return category.key == 'total' || category.key == 'remedial_flight' || category.key == 'remedial_simu' ? 'mb-1 font-weight-bold' : 'mb-1';
            },

            catDetails: function(category) {
                var res = category.duration+' '+this.lang.polaris.flight_hours.hour_s_lc;
                res += ', '+category.count+' '+this.lang.polaris.flight_hours.session_s_lc;
                return res;
            },

            serieDetails: function(serie) {
                var title = lang.polaris.options['serie_' + serie.serieKey];
                return title + ': ' + serie.duration + 'h';
            }
        }
    }
</script>
